import { type FieldValues, useController } from 'react-hook-form';
import type {
  FormControlProps,
  TypedUseControllerProps,
} from '../FormControl/FormControl.types';
import { SwitchField, type SwitchFieldProps } from '../SwitchField/SwitchField';

export type FormSwitchProps<TFieldValues extends FieldValues = FieldValues> =
  TypedUseControllerProps<TFieldValues, boolean> &
    FormControlProps<SwitchFieldProps>;

/*
 *  FormSwitch encapsulates the Switch component and provides a form control with validation to be used with React Hook Form.
 */
export const FormSwitch = <TFieldValues extends FieldValues = FieldValues>({
  disabled,
  ...props
}: FormSwitchProps<TFieldValues>) => {
  const {
    field: { ref, ...field },
    formState: { errors },
  } = useController(props);

  const error = errors[props.name]?.message?.toString();

  return (
    <SwitchField
      {...props}
      {...field}
      disabled={disabled}
      error={error}
      innerRef={ref}
    />
  );
};
